<template>
  <v-card class="pa-md-5" elevation="3">
    <!-- EDIT DELETE-->
    <v-dialog v-model="del" max-width="300px">
      <v-card>
        <v-card-title>Delete?</v-card-title>
        <v-card-text>
          Are you sure you want to delete {{ opportunity.name }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="delOp()">Yes</v-btn>
          <v-btn text color="error" @click="del = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- EDIT POPUP-->
    <v-dialog
      v-model="edit"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      persistent
      max-width="1200px"
    >
      <Edit
        :sync="sync"
        :close="close"
        :name="opportunity.name"
        :text="opportunity.text"
        :applyOnPortal="opportunity.applyOnPortal"
        :applyLink="opportunity.applyLink"
        title="Edit Opportunity"
      ></Edit>
    </v-dialog>
    <!-- APPLICATIONS POPUP -->
    <v-dialog
      v-model="applications"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <Applications
        :applications="opportunity.applications"
        :close="closeApplications"
        :opportunity="opportunity"
      ></Applications>
    </v-dialog>
    <v-card-title>{{ opportunity.name }}</v-card-title>
    <v-card-text v-html="opportunity.text"></v-card-text>
    <v-card-actions>
      <!-- Delete BUTTON -->
      <v-btn large @click="del = true" color="error">
        <v-icon>delete</v-icon>
        <div class="d-none d-md-flex">Delete</div>
      </v-btn>
      <v-spacer></v-spacer>

      <!-- EDIT BUTTON -->
      <v-btn large @click="edit = true" color="primary">
        <v-icon>edit</v-icon>
        <div class="d-none d-md-flex">Edit</div>
      </v-btn>

      <!-- APPLICATION Button -->
      <v-badge
        v-if="opportunity.applyOnPortal"
        class="ml-2"
        overlap
        top
        color="red"
      >
        <template v-slot:badge v-if="countUnseen > 0">
          {{ countUnseen }} new
        </template>
        <span slot="default">
          <v-btn @click="applications = true" large color="primary">
            <div>Applications</div>
          </v-btn>
        </span>
      </v-badge>
    </v-card-actions>
  </v-card>
</template>

<script>
import Edit from "./Edit2";
import Applications from "./Applications";

export default {
  fiery: true,
  props: ["opportunity"],
  components: { Edit, Applications },
  data: function() {
    return {
      edit: false,
      applications: false,
      del: false,
      OpenClose: "Close"
    };
  },
  methods: {
    sync(name, text, applyOnPortal, applyLink) {
      this.opportunity.name = name;
      this.opportunity.text = text;
      this.opportunity.applyOnPortal = applyOnPortal;
      this.opportunity.applyLink = applyLink;
      this.$fiery.sync(this.opportunity);
      this.close();
    },
    close() {
      this.edit = false;
    },
    closeApplications() {
      this.applications = false;
      this.opportunity.applications.forEach(application => {
        application.seen = true;
        this.$fiery.sync(application);
      });
    },
    delOp() {
      this.opportunity.deleted = true;
      this.$fiery.sync(this.opportunity);
    },
    OpenCloseFunc() {}
  },
  computed: {
    countUnseen: function() {
      return this.opportunity.applications.filter(o => !o.seen).length;
    }
  }
};
</script>